import { IconV2 } from 'components/common/IconV2/IconV2';
import type { MediumIconV2Props } from 'components/common/IconV2/IconV2.types';

const MinusCircleIcon = (props: MediumIconV2Props) => (
  <IconV2 {...props} viewBox="0 0 32 32">
    <circle cx="16" cy="16" r="14" stroke="currentcolor" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10" />
    <path stroke="currentcolor" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10" d="M10.274 15.833H22.06h-1.768" />
  </IconV2>
);

export default MinusCircleIcon;
